document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.product-grid-container');
  if (!container) return;

  container.addEventListener('click', (event) => {
    const button = event.target.closest('[data-filter-button]');
    if (!button) return;

    const productGrid = container.querySelector('#product-grid');
    const allButtons = document.querySelectorAll('[data-filter-button]');
    if (!productGrid) return;

    const products = productGrid.querySelectorAll('li.grid__item');
    const filterValue = button.dataset.filterButton;

    // Update button active state
    allButtons.forEach(btn => btn.classList.remove('is-active'));
    button.classList.add('is-active');

    // Filter products
    products.forEach(product => {
      const productTags = product.dataset.tags;
      
      if (filterValue === 'all') {
        product.style.display = 'block';
        return;
      }

      if (!productTags) {
        product.style.display = 'none';
        return;
      }

      // We split the tags and trim whitespace, then check for an exact match.
      const productTagsArray = productTags.split(',').map(tag => tag.trim());

      if (productTagsArray.includes(filterValue)) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    });
  });
});